import { LOCALE_ID, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AgGridModule } from 'ag-grid-angular';
import { AlertComponent } from './components/alert';
import { HeaderComponent } from '../views/pages/auth/header/header.component';
import { CellActionsComponent } from './components/dynamic-table/cell-actions/cell-actions.component';
import { CellPriorityComponent } from './components/dynamic-table/cell-prority/cell-priority.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { AgGridTableComponent } from './components/dynamic-table/ag-grid-table/ag-grid-table.component';
import { ExtendedInputComponent } from './components/extended-input/extended-input.component';
import { CellActionsUsersComponent } from './components/dynamic-table/cell-actions-users/cell-actions-users.component';
import { AuditLogsTableComponent } from './components/audit-logs-table/audit-logs-table.component';
import localeHe from '@angular/common/locales/he';
import { registerLocaleData } from '@angular/common';
import { FilterButtonsComponent } from './components/dynamic-table/filter-buttons/filter-buttons.component';
import { FormsModule } from '@angular/forms';
import { BulkButtonsComponent } from './components/dynamic-table/bulk-buttons/bulk-buttons.component';
import { MarkRequiredDirective } from './directives/mark-required.directive';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { CellActionsUsersRolesComponent } from './components/dynamic-table/cell-actions-users-roles/cell-actions-users-roles.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ClassificationComponent } from './components/dynamic-table/classification/classification.component';
import { LanguageComponent } from './components/dynamic-table/language/language.component';
import { StatusCellComponent } from './components/dynamic-table/status-cell/status-cell.component';
import { UserStatusComponent } from './components/dynamic-table/user-status/user-status.component';
import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';
import { CellSourceComponent } from './components/dynamic-table/cell-source/cell-source.component';


registerLocaleData(localeHe);

// Note we need a separate function as it's required
// by the AOT compiler.
export function playerFactory(): any {
  return player;
}

const components = [
  AlertComponent,
  HeaderComponent,
  ExtendedInputComponent,
  AgGridTableComponent,
  CellActionsComponent,
  CellActionsUsersComponent,
  CellActionsUsersRolesComponent,
  CellPriorityComponent,
  CellSourceComponent,
  ExtendedInputComponent,
  AuditLogsTableComponent,
  FilterButtonsComponent,
  BulkButtonsComponent,
  MarkRequiredDirective,
  ConfirmationDialogComponent,
  ProgressBarComponent,
  ClassificationComponent,
  LanguageComponent,
  StatusCellComponent,
  UserStatusComponent
] ;

const modules = [];

@NgModule({
  declarations: [...components],
  exports: [...components, ...modules, CommonModule, TranslateModule,
    AgGridModule.withComponents([CellActionsComponent, CellPriorityComponent, ClassificationComponent,
      LanguageComponent, StatusCellComponent])],
  imports: [
    ...modules,
    CommonModule,
    RouterModule,
    TranslateModule,
    NgbModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatProgressBarModule,
    AgGridModule.withComponents([CellActionsComponent, CellPriorityComponent, ClassificationComponent,
      LanguageComponent, StatusCellComponent]),
    FormsModule,
    LottieModule.forRoot({ player: playerFactory })
  ],
  providers: [{ provide: LOCALE_ID, useValue: 'he' }],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [],
    };
  }
}
